// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".YpDT5du_JNxK_5ejEvtg{display:flex;flex-direction:column;justify-content:center;align-items:center}.q5sJOst6DorwD2oed4yz{color:#f56565 !important;margin-bottom:14px}.sb8AMqFfMOpMBxIQheGs{margin-bottom:14px;text-align:center}@media(min-width: 768px){.sb8AMqFfMOpMBxIQheGs{margin-bottom:20px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noData": "YpDT5du_JNxK_5ejEvtg",
	"noDataTitle": "q5sJOst6DorwD2oed4yz",
	"noDataText": "sb8AMqFfMOpMBxIQheGs"
};
export default ___CSS_LOADER_EXPORT___;
